import { TIER_META } from "@/constants";

/**
 * GemBadge — badge visual de "Piedra Preciosa" para un tier dado.
 * Uso: <GemBadge tier="partner" size="md" variant="pill" />
 *  · sizes: xs · sm · md · lg
 *  · variants: pill (default) · block · minimal
 */
export default function GemBadge({ tier, size = "md", variant = "pill", className = "", withIcon = true }) {
  const meta = TIER_META[tier] || TIER_META.commercial;
  if (!meta) return null;

  const sizes = {
    xs: { text: "text-[9px]", pad: "px-1.5 py-0.5", gap: "gap-1", icon: "text-[10px]" },
    sm: { text: "text-[10px]", pad: "px-2 py-0.5", gap: "gap-1", icon: "text-xs" },
    md: { text: "text-xs", pad: "px-2.5 py-1", gap: "gap-1.5", icon: "text-sm" },
    lg: { text: "text-sm", pad: "px-3 py-1.5", gap: "gap-2", icon: "text-base" },
  };
  const s = sizes[size] || sizes.md;

  if (variant === "minimal") {
    return (
      <span data-testid={`gem-badge-${tier}`} className={`inline-flex items-center ${s.gap} ${className}`}>
        {withIcon && <span className={s.icon} aria-hidden>{meta.gemIcon}</span>}
        <span className={`${s.text} font-bold uppercase tracking-widest`} style={{ color: meta.gemColor }}>
          {meta.gem}
        </span>
      </span>
    );
  }

  if (variant === "block") {
    return (
      <div data-testid={`gem-badge-${tier}`}
        className={`inline-flex items-center justify-center ${s.gap} ${s.pad} rounded-lg font-bold uppercase tracking-widest ${s.text} ${className}`}
        style={{ background: meta.gemColor + "22", color: meta.gemColor, border: `1px solid ${meta.gemColor}` }}>
        {withIcon && <span className={s.icon} aria-hidden>{meta.gemIcon}</span>}
        <span>Nivel {meta.gem}</span>
      </div>
    );
  }

  // pill default
  return (
    <span data-testid={`gem-badge-${tier}`}
      className={`inline-flex items-center ${s.gap} ${s.pad} rounded-full font-bold uppercase tracking-widest ${s.text} ${className}`}
      style={{ background: meta.gemColor + "22", color: meta.gemColor, border: `1px solid ${meta.gemColor}` }}>
      {withIcon && <span className={s.icon} aria-hidden>{meta.gemIcon}</span>}
      Nivel {meta.gem}
    </span>
  );
}
